import { Mutator } from 'final-form';
import setFieldData from 'final-form-set-field-data';
import setFieldTouched from 'final-form-set-field-touched';

const setValue: Mutator = ([name, newValue], state, { changeValue }) => {
  changeValue(state, name, (value) => newValue);
};

export const formMutators = { setValue, setFieldData, setFieldTouched };
